/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Redux/TelemetryActions" />
import { ActionsUnion, createAction, trackedAction, trackedErrorAction } from "redux/Utils/ActionHelper";

export const TelemetryActions = {
    publishTelemetry: (action: string, properties?: { [key: string]: any }) =>
        trackedAction(createAction(TelemetryActionTypes.publishTelemetry), { action, ...properties }),
    publishErrorTelemetry: (action: string, properties?: { [key: string]: any }) =>
        trackedErrorAction(createAction(TelemetryActionTypes.publishTelemetry, { action, ...properties }))
};

export const enum TelemetryActionTypes {
    publishTelemetry = "TestHubRefresh"
}

export type TelemetryAction = ActionsUnion<typeof TelemetryActions>;
